import { COUNTRIES } from "../constants/countries";

export function getIso2CodeFromCountry(country: string): string {
  if (!country) {
    return "";
  }

  const countryData = COUNTRIES.find(
    (c) => c.name.toLowerCase() === country.toLowerCase(),
  );
  return countryData ? countryData.code : "";
}
